import { render, staticRenderFns } from "./BankReceiptsForm.vue?vue&type=template&id=646748fd&scoped=true"
import script from "./BankReceiptsForm.vue?vue&type=script&lang=js"
export * from "./BankReceiptsForm.vue?vue&type=script&lang=js"
import style0 from "./BankReceiptsForm.vue?vue&type=style&index=0&id=646748fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646748fd",
  null
  
)

export default component.exports